export enum ComponentTypeEnum {
    TITLE = 'title',
    PARAGRAPH = 'paragraph',
    IMAGE = 'image',
    IMAGE_AND_PARAGRAPH = 'image_paragraph',
    LISTING = 'listing',
}
